import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Badge, Modal, Spinner, Pagination } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
    fetchNoPeanutPolicies,
    selectPolicies,
    selectMeta,
    selectLoading,
    selectError
} from '../../store/noPeanutPolicy/noPeanutPolicySlice';
import { getEffectiveStudentId } from '../../utilities/teacherModulePermissions';

const NoPeanutPolicyListComp = ({ data, viewMode }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const policies = useSelector(selectPolicies) || [];
    const meta = useSelector(selectMeta);
    const loading = useSelector(selectLoading);
    const error = useSelector(selectError);
    let profileData = useSelector((state) => state.setting.setting.user_data);
    profileData = profileData ? JSON.parse(profileData) : null;

    const [currentPage, setCurrentPage] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [selectedPolicy, setSelectedPolicy] = useState(null);

    useEffect(() => {
        dispatch(fetchNoPeanutPolicies({ page: currentPage, limit: 10, student_id: getEffectiveStudentId(profileData) }));
    }, [dispatch, currentPage]);
    // Always call hooks first
    // In profile view, always use the passed-in data prop (already filtered by parent)
    if (viewMode === 'profile') {
        if (!Array.isArray(data) || data.length === 0) {
            // Show nothing if no active data (parent will show form)
            return null;
        }
        // Render only the passed-in data
        return (
            <Container>
                <Row>
                    {data.map((policy) => (
                        <Col md="12" key={policy.id} className="mb-3">
                            <Card className="border">
                                <Card.Body>
                                    <Row className="align-items-center">
                                        <Col md="6">
                                            <h6 className="mb-2">
                                                Policy #{policy.id}
                                                <Badge bg="success" className="ms-2">Active</Badge>
                                            </h6>
                                            <p className="mb-1 text-muted">
                                                <strong>Submitted:</strong> {policy.created_at}
                                            </p>
                                            <p className="mb-1">
                                                <strong>Description:</strong> {policy.description || 'N/A'}
                                            </p>
                                            {policy.parent_signature && (
                                                <div className="mt-2">
                                                    <strong>Parent Signature:</strong>
                                                    <div className="mt-1">
                                                        <img
                                                            src={policy.parent_signature}
                                                            alt="Parent Signature"
                                                            style={{ maxWidth: '200px', maxHeight: '80px', border: '1px solid #ddd', borderRadius: '4px', padding: '4px' }}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </Col>
                                        <Col md="6" className="d-flex gap-2 justify-content-end">
                                            <Button
                                                variant="info"
                                                size="sm"
                                                onClick={() => setShowModal(true)}
                                            >
                                                <i className="icon material-symbols-outlined me-1" style={{ verticalAlign: 'middle' }}>visibility</i>
                                                View
                                            </Button>
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                onClick={() => navigate(`/dashboard/no-peanut-policy/edit/${policy.id}`)}
                                            >
                                                <i className="icon material-symbols-outlined me-1" style={{ verticalAlign: 'middle' }}>edit</i>
                                                Edit
                                            </Button>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        );
    }
    // Add handlePageChange for pagination
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleViewDetails = (policy) => {
        setSelectedPolicy(policy);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedPolicy(null);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        if (isNaN(date.getTime()) || dateString.includes('Invalid') || dateString.includes('1899-11-29')) {
            return 'N/A';
        }
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    };

    const renderPagination = () => {
        if (!meta || meta.last_page <= 1) return null;

        const items = [];
        for (let number = 1; number <= meta.last_page; number++) {
            items.push(
                <Pagination.Item
                    key={number}
                    active={number === currentPage}
                    onClick={() => handlePageChange(number)}
                >
                    {number}
                </Pagination.Item>
            );
        }

        return (
            <Pagination className="justify-content-center mt-3">
                <Pagination.Prev
                    key="prev"
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                />
                {items}
                <Pagination.Next
                    key="next"
                    disabled={currentPage === meta.last_page}
                    onClick={() => handlePageChange(currentPage + 1)}
                />
            </Pagination>
        );
    };

    if (loading && (!policies || policies.length === 0)) {
        return (
            <Container>
                <div className="text-center py-5">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            </Container>
        );
    }

    if (error) {
        return (
            <Container>
                <Card>
                    <Card.Body className="text-center py-5">
                        <p className="text-danger">Error: {error}</p>
                        <Button variant="primary" onClick={() => dispatch(fetchNoPeanutPolicies({ page: 1, limit: 10, student_id: getEffectiveStudentId(profileData) }))}>
                            Retry
                        </Button>
                    </Card.Body>
                </Card>
            </Container>
        );
    }

    return (
        <Container>
            <Row>
                <Col sm="12">
                    {/* <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <div className="header-title">
                                <h4 className="card-title">No Peanut Policy</h4>
                            </div>
                            <Link to="/dashboard/no-peanut-policy/add">
                                <Button variant="primary" size="sm">
                                    <i className="icon material-symbols-outlined me-1" style={{ verticalAlign: 'middle' }}>add</i>
                                    Create New Policy
                                </Button>
                            </Link>
                        </Card.Header>
                        <Card.Body> */}
                    {!Array.isArray(policies) || policies.length === 0 ? (
                        <div className="text-center py-5">
                            <i className="icon material-symbols-outlined" style={{ fontSize: '64px', color: '#ccc' }}>
                                description
                            </i>
                            <p className="mt-3 text-muted">No policies found. Create your first policy.</p>
                            <Link to="/dashboard/no-peanut-policy/add">
                                <Button variant="primary">Create Your First Policy</Button>
                            </Link>
                        </div>
                    ) : (
                        <Row>
                            {policies.map((policy) => (
                                <Col md="12" key={policy.id} className="mb-3">
                                    <Card className="border">
                                        <Card.Body>
                                            <Row className="align-items-center">
                                                <Col md="6">
                                                    <h6 className="mb-2">
                                                        Policy #{policy.id}
                                                        <Badge
                                                            bg={policy.status === 1 ? "success" : "secondary"}
                                                            className="ms-2"
                                                        >
                                                            {policy.status === 1 ? "Active" : "Inactive"}
                                                        </Badge>
                                                    </h6>
                                                    <p className="mb-1 text-muted">
                                                        <strong>Submitted:</strong> {formatDate(policy.created_at)}
                                                    </p>
                                                    <p className="mb-1">
                                                        <strong>Description:</strong> {policy.description || 'N/A'}
                                                    </p>
                                                    {policy.parent_signature && (
                                                        <div className="mt-2">
                                                            <strong>Parent Signature:</strong>
                                                            <div className="mt-1">
                                                                <img
                                                                    src={policy.parent_signature}
                                                                    alt="Parent Signature"
                                                                    style={{ maxWidth: '200px', maxHeight: '80px', border: '1px solid #ddd', borderRadius: '4px', padding: '4px' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                </Col>
                                                <Col md="6" className="text-end">
                                                    <div className="d-flex gap-2">
                                                        <Button
                                                            variant="info"
                                                            size="sm"
                                                            onClick={() => handleViewDetails(policy)}
                                                        >
                                                            <i className="icon material-symbols-outlined me-1" style={{ verticalAlign: 'middle' }}>visibility</i>
                                                            View
                                                        </Button>
                                                        {policy.status === 1 && (
                                                            <Link to={`/dashboard/no-peanut-policy/edit/${policy.id}`}>
                                                                <Button
                                                                    variant="primary"
                                                                    size="sm">
                                                                    <i className="icon material-symbols-outlined me-1" style={{ verticalAlign: 'middle' }}>edit</i>
                                                                    Edit
                                                                </Button>
                                                            </Link>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    )}
                    {renderPagination()}
                    {/* </Card.Body>
                    </Card> */}
                </Col>
            </Row>

            {/* View Details Modal */}
            <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>No Peanut Policy Details - #{selectedPolicy?.id}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    {selectedPolicy && (
                        <>
                            <Row className="mb-3">
                                <Col md="6">
                                    <strong>Status:</strong>
                                    <Badge
                                        bg={selectedPolicy.status === 1 ? "success" : "secondary"}
                                        className="ms-2"
                                    >
                                        {selectedPolicy.status === 1 ? "Active" : "Inactive"}
                                    </Badge>
                                </Col>
                                <Col md="6">
                                    <strong>Submitted Date:</strong> {formatDate(selectedPolicy.created_at)}
                                </Col>
                            </Row>

                            <hr />

                            <Row className="mb-3">
                                <Col md="12">
                                    <strong>Description:</strong>
                                    <p className="mt-2">{selectedPolicy.description || 'N/A'}</p>
                                </Col>
                            </Row>

                            <hr />

                            <h6 className="mb-3">Signature Details</h6>
                            <Row className="mb-3">
                                <Col md="12">
                                    <strong>Parent Signature:</strong>
                                    {selectedPolicy.parent_signature ? (
                                        <div className="mt-2">
                                            <img
                                                src={selectedPolicy.parent_signature}
                                                alt="Parent Signature"
                                                style={{ maxWidth: '400px', maxHeight: '150px', border: '1px solid #ddd', borderRadius: '4px', padding: '8px' }}
                                            />
                                            <p className="mt-2 mb-0">
                                                <strong>Date:</strong> {formatDate(selectedPolicy.parent_signature_date)}
                                            </p>
                                        </div>
                                    ) : (
                                        <p className="mt-2 text-muted">No signature available</p>
                                    )}
                                </Col>
                            </Row>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                    {selectedPolicy?.status === 1 && (
                        <Link to={`/dashboard/no-peanut-policy/edit/${selectedPolicy.id}`}>
                            <Button variant="primary" onClick={handleCloseModal}>
                                <i className="icon material-symbols-outlined me-1" style={{ verticalAlign: 'middle' }}>edit</i>
                                Edit
                            </Button>
                        </Link>
                    )}
                </Modal.Footer>
            </Modal>
        </Container>
    );
};
export default NoPeanutPolicyListComp;
